/** Driver declarations — Preferences CRUD + booking form / public page helpers (migration 168). */
import { supabase } from "@/lib/supabaseClient";

const COLS = "id,client_id,statement,short_label,is_required,is_active,site_ids,direction,sort_order";

export function listDriverDeclarations(clientId) {
  return supabase.from("lbs_driver_declarations").select(COLS)
    .eq("client_id", clientId).order("sort_order").order("created_at");
}

export function saveDriverDeclaration(row) {
  const { id, ...rest } = row;
  const payload = { ...rest, updated_at: new Date().toISOString() };
  return id
    ? supabase.from("lbs_driver_declarations").update(payload).eq("id", id).select(COLS).maybeSingle()
    : supabase.from("lbs_driver_declarations").insert(payload).select(COLS).maybeSingle();
}

export function deleteDriverDeclaration(id) {
  return supabase.from("lbs_driver_declarations").delete().eq("id", id);
}

export function declarationsForBooking(siteId, direction) {
  return supabase.rpc("lbs_booking_declarations_for", { p_site_id: siteId, p_direction: direction || null });
}

export function publicDeclarations(slug, direction) {
  return supabase.rpc("lbs_public_declarations", { p_slug: slug, p_direction: direction || null });
}

export function setBookingDeclarations(bookingId, answers, slug = null) {
  return supabase.rpc("lbs_set_booking_declarations", {
    p_booking_id: bookingId, p_answers: answers || {}, p_slug: slug,
  });
}

/** {id: bool} answers from a stored booking snapshot. */
export const answersFromSnapshot = (snapshot) =>
  Object.fromEntries((Array.isArray(snapshot) ? snapshot : []).map((d) => [d.id, !!d.answer]));

/** Short labels of required declarations that aren't ticked. */
export const missingRequired = (list, answers) =>
  (list || []).filter((d) => d.is_required && !(answers || {})[d.id]).map((d) => d.short_label);

/** Snapshot items that are required but weren't ticked — "to confirm at arrival". */
export const outstandingFromSnapshot = (snapshot) =>
  (Array.isArray(snapshot) ? snapshot : []).filter((d) => d.required && !d.answer);

export const DEFAULT_DECLARATIONS_NOTICE =
  "Items marked * are mandatory for site access. Anything not confirmed now must be confirmed on arrival before access to the site or bay is granted.";

/** Notice wording for a form (site override > tenant > standard) — migration 170. */
export function declarationsNotice(siteId) {
  return supabase.rpc("lbs_declarations_notice", { p_site_id: siteId, p_slug: null });
}

export function publicDeclarationsNotice(slug) {
  return supabase.rpc("lbs_public_declarations_notice", { p_slug: slug });
}

export function listDeclarationNotices(clientId) {
  return supabase.from("lbs_declaration_notices").select("id,client_id,site_id,notice").eq("client_id", clientId);
}

/** Save (or clear, when notice is blank) the tenant (siteId null) or site wording. */
export async function saveDeclarationNotice(clientId, siteId, notice, existingId) {
  const text = (notice || "").trim();
  if (!text) {
    return existingId ? supabase.from("lbs_declaration_notices").delete().eq("id", existingId) : { error: null };
  }
  const payload = { client_id: clientId, site_id: siteId || null, notice: text, updated_at: new Date().toISOString() };
  return existingId
    ? supabase.from("lbs_declaration_notices").update(payload).eq("id", existingId)
    : supabase.from("lbs_declaration_notices").insert(payload);
}
